import React from "react";

import Header from "../components/header";
import DividerBottom from "../components/divider-bottom";
import Footer from "../components/footer";

import CubsLogo from "../assets/images/cubs_logo.png";
import CubsUniform from "../assets/images/cubs-uniform.png";
import CubsBadgePlacement from "../assets/images/cubs-badge-placement.png";

function Cubs() {
    return (
        <>
            <Header />

            <main id="cubs">
                <div className="sections-container">
                    <div className="section-item">
                        <img src={CubsLogo} alt="Cubs"></img>
                        <p>8 - 10½ Years</p>
                        <p>Term-time Tuesdays 6:15 - 7:30pm</p>
                    </div>
                </div>
                <section id="section-details">
                    <section id="about-section">
                        <h1>About Cubs</h1>
                        <ul>
                            <li>Cubs are our second youngest members, aged between 8 and 10 ½ years old.</li>
                            <li>They typically meet for an hour and a quarter per week.</li>
                            <li>As Cubs, the children get to experience a wider array of activities, such as climbing, archery and paddleboarding.</li>
                            <li>During their time in Cubs, the children will also get the opportunity to go on longer and more adventurous camps.</li>
                        </ul>
                    </section>
                    <section id="leaders-section">
                        <h1>Who runs the section?</h1>
                        <p>The Cub pack at the 17th is run by a team of hardworking volunteers, who dedicate their time to making sure your children experience the best that Scouting has to offer.</p>
                        <ul>
                            <li>Section Leader: Akela</li>
                            <li>Assistant Section Leader: Bagheera</li>
                            <li>Assistant Section Leader: Hawkeye</li>
                            <li>Assistant Section Leader: Rocky</li>
                            <li>Section Assistant: Baloo</li>
                            <li>Section Assistant: Bubbles</li>
                            <li>Section Assistant: Ed</li>
                            <li>Section Assistant: Youngblood</li>
                            <li>Young Leader: Kaa</li>
                        </ul>
                    </section>
                    <section id="promise-section">
                        <h1>The Cub Promise and Law</h1>
                        <h2>The Cub Promise</h2>
                        <ul>
                            <li>I promise that I will do my best</li>
                            <li>To help other people</li>
                            <li>And to keep the Cub Scout Law</li>
                        </ul>
                        <br></br>
                        <h2>The Cub Law</h2>
                        <ul>
                            <li>Cub Scouts always do their best</li>
                            <li>Think of others before themselves</li>
                            <li>And do a good turn every day</li>
                        </ul>
                    </section> 
                </section>
                
                <section id="uniform-info">
                    <h1>Uniform and Badges</h1>
                    <div className="uniform-info-container">
                        <div className="uniform-info-item">
                            <h3>What Cubs wear</h3>
                            <p>Cub Scouts wear a green sweatshirt and a neckerchief with a coloured woggle showing what patrol they are in. They usually pair this with our group t-shirt and navy blue activity trousers or shorts, sometimes adding a belt. We expect Cubs to wear sturdy footwear as they will be doing lots of adventurous activities.</p>
                        </div>
                        <div className="uniform-info-item">
                            <h3>Why uniform is important</h3>
                            <p>Wearing a uniform is comfy and practical and means you can run around and get messy without ruining your other clothes. It makes you feel part of a team and means no one feels uncomfortable or left out. It also gives you a place to show off all the brilliant badges you earn.</p>
                        </div>
                        <div className="uniform-info-item">
                            <h3>Where you can buy the uniform</h3>
                            <p>Uniform can either be bought from the online Scout Association shop - <a href="https://shop.scouts.org.uk/" target="_blank">Scout Store</a> - or from a local supplier such as the Butchers Coppice Scout shop or some school uniform shops. If you're stuck, ask us to tell you more about what to buy and where to buy it. If cost is an issue, we may have some second-hand kit available.</p>
                        </div>
                    </div>
                </section>
                
                <section id="uniform-images">
                    <div className="uniform-images-container">
                        <img src={CubsUniform} alt="Cub Uniform Diagram"></img>
                        <img src={CubsBadgePlacement} alt="Cubs Badge Placement Diagram"></img>
                    </div>
                </section>
            <DividerBottom />
            </main>
            <Footer />
        </>
    );
}

export default Cubs;